module.exports = __webpack_public_path__ + "static/media/instagram.0dbc8dd2.svg";